<template>
  <div class="get-today-modal">
    <ModalAsideHeader>
      {{ messages.getToday }}
    </ModalAsideHeader>
    <ModalAsideBody v-if="!currentReserveShop">
      <GetTodayList :result="product" :messages="messages" @reserve="handlerReserve" />
    </ModalAsideBody>
    <GetTodayDetail
      v-else
      :result="product"
      :reserve-shop="currentReserveShop"
      :messages="messages"
    />
  </div>
</template>

<script lang="ts" setup>
import ModalAsideHeader from '@use/useModalAside/ModalAsideHeader.vue';
import { useStore } from '@/store';
import { computed, ref } from 'vue';
import ModalAsideBody from '@use/useModalAside/ModalAsideBody.vue';
import GetTodayList from '@components/Product/GetToday/GetTodayList.vue';
import GetTodayDetail from '@components/Product/GetToday/GetTodayDetail.vue';

const { state } = useStore();
const messages = computed(() => state.product.data.messages);
const product = computed(() => state.product.data.product);

const currentReserveShop = ref(null);

const handlerReserve = (item) => {
  currentReserveShop.value = item;
};
</script>

<style lang="scss" scoped>
.get-today-modal {
  height: 100%;
}
</style>
